import { EmptyBookingPartner } from '~/components/booking-review/booking-partner';
import { AppointmentInformation } from '../components';

export const config = {
  BookingReview: {
    BookingPartner: EmptyBookingPartner,
  },
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
    additionalInfoText: `Please note, this appointment is to understand your design preferences before
      we visit your home - we will not be planning your project at this stage.`,
  },
};
